/**
 * The task statuses that count as open, for queries.
 *
 * The same set as isOpenTask (features/calendar/grantWork.ts) reads in
 * memory: every task is written with one of todo, doing, done or cancelled
 * (taskSchema in @claripick/shared), so "not done and not cancelled" is
 * exactly "todo or doing". Asking Firestore for these rather than for every
 * task keeps a read that used to grow with every task ever closed to the
 * size of the work still in hand. firestore.indexes.json carries the
 * (status, createdAt desc) index the queries need.
 */
export const OPEN_TASK_STATUSES = ['todo', 'doing'] as const;

/** Closed tasks, fetched only when someone asks to see them. */
export const CLOSED_TASK_STATUSES = ['done', 'cancelled'] as const;
